import { render } from "./GestaoApiConecta.vue?vue&type=template&id=b22eb7c8&scoped=true&ts=true"
import script from "./GestaoApiConecta.vue?vue&type=script&lang=ts"
export * from "./GestaoApiConecta.vue?vue&type=script&lang=ts"

import "./GestaoApiConecta.vue?vue&type=style&index=0&id=b22eb7c8&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b22eb7c8"]])

export default __exports__